export function isRelativeUrl(url) {
    return url && !url.startsWith('http://') && !url.startsWith('https://');
}
//# sourceMappingURL=isRelativeUrl.js.map